import {withTranslation} from '@wix/yoshi-flow-editor'
import {isMobile} from '../../../../commons/selectors/environment'
import {getMembers, getTotalGuests} from '../../selectors/event'
import {DetailsPageAppProps} from '../app/interfaces'
import {connect} from '../runtime-context/context'
import {MembersRuntimeProps} from './interfaces'
import {Members as MembersPresentation} from './members'

const mapRuntime = ({state, actions: {openMembersModal}}: DetailsPageAppProps): MembersRuntimeProps => ({
  event: state.event,
  totalGuests: getTotalGuests(state),
  members: getMembers(state),
  openMembersModal,
  mobile: isMobile(state),
})

export const Members = connect<{}, MembersRuntimeProps>(mapRuntime)(withTranslation()(MembersPresentation))
export * from './interfaces'
